import Vue from 'vue';
import Vuex from 'vuex';
import http from './http';
import router from './router';
import createPersistedState from 'vuex-persistedstate';
import notify from './notifications';
import { getUserFromToken } from './auth/index';

Vue.use( Vuex );

export default new Vuex.Store( {
    state: {
        appLoading: false,
        token: null,
        user: null,
        campaignsList: [],
        propertyTypes: [],
        listingTypes: [],
        propertyFeatures: []
    },
    mutations: {
        auth( state, token ) {
            state.token = token;
            let user = getUserFromToken( token );
            state.user = user;
        },
        clearAuthData( state ) {
            localStorage.removeItem( 'token' );
            localStorage.removeItem( 'refreshToken' );
            localStorage.removeItem( 'useremail' );
            localStorage.removeItem( 'username' );
            state.token = null;
            state.user = null;
        },
        setPropertyTypes( state, propertyTypes ) {
            state.propertyTypes = propertyTypes;
        },
        setListingTypes( state, listingTypes ) {
            state.listingTypes = listingTypes;
        },
        setPropertyfeatures( state, propertyFeatures ) {
            state.propertyFeatures = propertyFeatures;
        },
        setAppLoading( state, isLoading = false ) {
            state.appLoading = isLoading;
        }
    },
    actions: {
        async login( { commit, dispatch, state }, credentials ) {
            dispatch( 'appLoading', true );

            const baseURL = process.env.AUTH_API_URL;

            const options = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify( credentials )
            };

            const response = await fetch( `${baseURL}/internal/auth`, options );

            const responseJSON = await response.json();

            if ( response.status !== 401 && response.status !== 200 && !response.ok ) {
                notify( {
                    type: 'error',
                    title: 'Credentials Failed',
                    text: ( responseJSON.code && responseJSON.message ) ? `${responseJSON.code}: ${responseJSON.message}` : 'Login failed, please try again'
                } );
                dispatch( 'appLoading', false );
                return;
            }

            if ( response.status === 401 ) {
                notify( {
                    type: 'error',
                    title: 'Credentials Failed',
                    text: `${responseJSON.code}: ${responseJSON.message}`
                } );
                dispatch( 'appLoading', false );
                return;
            }

            const accessToken = responseJSON.accessToken;
            const refreshToken = responseJSON.refreshToken;

            localStorage.setItem( 'token', accessToken );
            localStorage.setItem( 'refreshToken', refreshToken );

            commit( 'auth', accessToken );

            dispatch( 'appLoading', false );

            notify( {
                type: 'success',
                title: 'Welcome',
                text: 'Logged in as ' + this.state.user.Email
            } );

            if ( localStorage.getItem( 'token' ) ) {
                router.replace( router.currentRoute.query.returnUrl || '/dashboard' );
            } else {
                if ( state.token !== null ) {
                    localStorage.setItem( 'token', state.token );
                }
                router.replace( router.currentRoute.query.returnUrl || '/' );
            }

            dispatch( 'appLoading', false );
        },
        tryAutoLogin( { commit } ) {
            const token = localStorage.getItem( 'token' );
            if ( !token ) {
                return;
            }

            commit( 'auth', token );
        },
        logout( { commit, dispatch } ) {
            dispatch( 'appLoading', true );
            commit( 'clearAuthData' );
            setTimeout( function() {
                dispatch( 'appLoading', false );
                notify( {
                    type: 'success',
                    title: 'Goodbye',
                    text: 'See you soon'
                } );
                
                router.replace( '/' );
            }, 300 );
        },
        async fetchPropertyTypes( { commit } ) {
            const response = await http.request( '/property-types' );
            commit( 'setPropertyTypes', await response.json() );
        },
        async fetchListingTypes( { commit } ) {
            const response = await http.request( '/property-listing-types' );
            commit( 'setListingTypes', await response.json() );
        },
        async fetchPropertyFeatures( { commit } ) {
            const response = await http.request( '/property-features' );
            commit( 'setPropertyfeatures', await response.json() );
        },
        appLoading( { commit }, isLoading = false ) {
            commit( 'setAppLoading', isLoading );
        }
    },
    getters: {
        user( state ) {
            return state.user;
        },
        email( state ) {
            return state.user.Email;
        },
        token( state ) {
            return state.token;
        },
        isAuthenticated( state ) {
            return state.token !== null;
        },
        propertyTypes( state ) {
            return state.propertyTypes;
        },
        listingTypes( state ) {
            return state.listingTypes;
        },
        propertyFeatures( state ) {
            return state.propertyFeatures;
        },
        isAppLoading( state ) {
            return state.appLoading;
        }
    },
    plugins: [
        createPersistedState()
    ]
} );



// WEBPACK FOOTER //
// ./src/store.js